import type { ProductStatus } from "@unbox/api";

export const PRODUCT_STATUSES: ProductStatus[] = [
  "ACTIVATE",
  "DRAFT",
  "PENDING",
  "SELLER_DEACTIVATED",
  "PLATFORM_DEACTIVATED",
  "DELETED",
  "FREEZE",
  "FAILED",
  "UNKNOWN",
];

export const PRODUCT_STATUS_LABELS: Record<ProductStatus, string> = {
  DRAFT: "Draft",
  PENDING: "Pending",
  FAILED: "Failed",
  ACTIVATE: "Active",
  SELLER_DEACTIVATED: "Seller Deactivated",
  PLATFORM_DEACTIVATED: "Platform Deactivated",
  FREEZE: "Frozen",
  DELETED: "Deleted",
  UNKNOWN: "Unknown",
};

// Stock Status types for product filtering
export type StockStatus = "in_stock" | "low_stock" | "out_of_stock";

export const STOCK_STATUSES: StockStatus[] = ["in_stock", "low_stock", "out_of_stock"];

export const STOCK_STATUS_LABELS: Record<StockStatus, string> = {
  in_stock: "In Stock",
  low_stock: "Low Stock",
  out_of_stock: "Out of Stock",
};
